<template>
    <div class="Details">
    <section>
        <div class="content">

            
            <!-- <div class="columns">
            <b-message class="box"
                
                type="is-info" 
                aria-close-label="Close message">
                <b>Create your dataset using inteligent tools to help you!</b><br>
                <br>
                We integrate with a set of providers: 
                <router-link :to="`/datasets/${dataset.id}/human-labeling`">Request human labeling service</router-link>
            </b-message>
            </div>
            <br> -->
            
            <div class="columns box">
                <div class="column is-6-desktop is-12-mobile">
                    <h4 class="title is-6">Analysis</h4>
                    
                    <p v-if="total != undefined">
                        
                        <!-- <b-tag type="is-info">{{this.dataset.labelBalance["count"].reduce((a, b) => a + b, 0)}}</b-tag> Labeled data<br>
                        <b-tag type="is-info">{{total}}</b-tag> Unlabaled data<br> -->
                        
                        
                        <b-tag type="is-info" v-if="total > 0">In progress</b-tag> 
                        <b-tag type="is-success" v-else>Complete</b-tag> 
                        
                        Total of {{ dataset.instances-total }} labeled documents<br>
                        <!-- {{total}} unlabeled data left<br> -->

                        


                        <!--{{ this.dataset.labelBalance }}-->
                        <!-- <b-tag type="is-info">Analysing</b-tag> Noises <br>
                        <b-tag type="is-info">Analysing</b-tag> Baseline model performance -->
                        <!-- {{ dataset.labels }} -->
                    </p>
                    <b-skeleton v-else width="100%" :animated="animated"></b-skeleton>
                    
                </div>
                <!-- <div class="column is-6-desktop is-12-mobile">
                    <h4 class="title is-6">Progress</h4>
                    <p>
                        
                        <b-tag type="is-info">Analysing</b-tag> 3/1000<br>
                        <b-tag type="is-info">Analysing</b-tag> Model <br>
                        <b-tag type="is-info">Analysing</b-tag> Performance
                    </p>
                </div> -->
            </div>
            
            <br>
            
            <div class="columns box" v-if="datasetDocuments != undefined && total != undefined ">
                <div class="column" v-if="total > 0">
                    <div class="columns is-mobile" >
                        <div class="column is-8-desktop is-12-mobile">
                            <h3 class="title is-6">Text</h3>
                            <article :class="'content ' + textSize" v-if="datasetDocuments[getCurrentId()]">
                                    {{ datasetDocuments[getCurrentId()].text }}
                                    <br>
                                    {{ candidateLabels }}
                                    <br>
                                    {{ datasetDocuments[getCurrentId()] }}
                            </article>
                            <article :class="'content ' + textSize" v-else>
                                    loading
                            </article>
                        </div>
                        <div class="column" v-if="datasetDocuments[getCurrentId()]">
                            <b-tooltip multilined>
                                <h3 class="title is-6">
                                    Labels
                                </h3>
                                <template v-slot:content>
                                    <b>Usage:</b>
                                    Click on the right label to annotate the data.<br>
                                    Annotate until the end.
                                </template>
                            </b-tooltip>
                            
                            <b-field v-for="(label, index) in candidateLabels"
                                    :key="index">
                                <b-radio-button v-model="datasetDocuments[getCurrentId()].label"
                                    :native-value="label"
                                    type="is-info is-light is-outlined"
                                    @input="saveAnnotationRadio">
                                    {{ label }}
                                </b-radio-button>
                            </b-field>
                        </div>
                    </div>
                    <div class="block is-centered">
                    {{ total }} unlabeled documents left
                    </div>
                    <!-- <b-pagination
                        :total="total"
                        v-model="current"
                        :range-before="rangeBefore"
                        :range-after="rangeAfter"
                        :order="order"
                        :size="size"
                        :simple="isSimple"
                        :rounded="isRounded"
                        :per-page="perPage"
                        :icon-prev="prevIcon"
                        :icon-next="nextIcon"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                        @change="saveAnnotationPagination">
                        
                    </b-pagination> -->
                </div>
                <div class="column" v-else>
                    <h3 class="title is-5">
                        Congrats! Data annotation is done.
                    </h3>
                    <div class="block is-centered">
                        0 unlabeled documents left
                    </div>
                </div>
                
            </div>
            <b-skeleton v-else width="100%" :animated="animated"></b-skeleton>
            <br><br>
        </div>
    </section>

    </div>
</template>
<script>
    import VueWordCloud from 'vuewordcloud';

   export default {
     props: ["dataset", "wordclouds"],
     name: "Data",
     data: function() {
    return {
        animated: true,
        annotated: false,
        is_uploading_data: false,
        textSize: 'is-large',
        textSizeOptions: ['is-large', 'is-normal', 'is-small'],
        
        currentLabel: '',
        texts: {},
        labels: {},
        total: undefined,
        total_labeled: 0,
        current: 1,
        perPage: 1,
        rangeBefore: 3,
        rangeAfter: 1,
        order: 'is-centered',
        size: '',
        isSimple: true,
        isRounded: false,
        prevIcon: 'chevron-left',
        nextIcon: 'chevron-right',
        
    }},
    components: {
        VueWordCloud
    },
    computed: {
       datasetDocuments() {
         //let doc = this.$store.state.datasetDocuments;
         //let doc = this.$store.state[`datasetDocuments-unlabeled`];
         let doc = this.$store.state.datasetDocumentsError;
         this.total = doc.length
         return doc
       }
     },
     methods: {
         saveAnnotationRadio(value){
             
            this.datasetDocuments[this.getCurrentId()].label = value
            this.save()
         },
         saveAnnotationPagination(current){
             
         },
         getCurrentId(){
             return 0 //this.current - 1
         },
         getCurrentLabel(){
             return this.labels[this.getCurrentId()]
         },
         save(){
            let currentDocument = this.datasetDocuments[this.getCurrentId()]
            let documentUpdate = {
                label: currentDocument.label
            }
            let documentId = this.datasetDocuments[this.getCurrentId()].id
            let datasetId = this.dataset.id

            const toUpdate = {
                datasetId: datasetId,
                docId: documentId,
                update: documentUpdate
            }

            // console.log(toUpdate)
            this.$store.dispatch("updateDatasetDocument", 
                toUpdate
            );

            this.update()
            
         },
         update(){
            const toUpdate = {
                datasetId: this.dataset.id,
                update: {
                    labeling_current: this.current
                }
            }
            this.$store.dispatch("updateDataset", 
                toUpdate
            );
         },
        //  next(){
        //     this.$store.dispatch("getNextDatasetDocuments", this.dataset.id);
        //  },
         selectCols(data_cols){
            return [{field:  'text', label: 'Text'},{field: 'label', label: 'Label'}]
         },
         calcLabeledData(){
            let _total_labeled = 0
            for(let i=0; i < this.dataset.labelBalance["count"].length; i++){
                if (this.dataset.labelBalance["labels"][i] != "unlabeled"){
                    _total_labeled + this.dataset.labelBalance["count"][i]
                }
            }
            return _total_labeled
         }
     },
     created() {
         
        this.$store.dispatch("getAllErrorDatasetDocuments", this.dataset.id);
        
        
        this.metadata = [...Array(this.total).keys()]
        if (this.dataset.labels.length) {
            this.candidateLabels = this.dataset.labels.sort((a,b) => a.localeCompare(b))
        } else {
            this.candidateLabels = this.dataset.labelBalance['labels']
        }

        if (this.dataset.labeling_current) {
            this.current = this.dataset.labeling_current
        }
        
        
        this.currentLabel = this.getCurrentLabel()

     }
   };
</script>

<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>